'use strict';

import { Buildings } from '../../settings';
import { PopUp } from '../interfaces/pages/PopUp';
import { BaseElement } from '../interfaces/BaseElement';
import Notiflix from 'notiflix';

export class Report {
	constructor (title) {
		this.log = [];
		this.message = '';
		this.title = title;
		this.jsonReport = [];
	}
	
	addError(apt,message = this.message,expected) {
		this.log.push({
			message: message ? message : this.message,
			apt,
			expected
		});
	}
	
	showReport() {
		const popUp = new PopUp({
			id: 'QA',
			needsCloseBtn: true,
			destroy: true
		});
		popUp.setTitle(this.title);
		
		const container = new BaseElement()
			.addClass('qa-report__container')
			.DOMElement;
		
		const area = new BaseElement('textarea')
			.addAttribute('cols',50)
			.addAttribute('rows',10)
			.addStyle('width','800px')
			.addStyle('height','400px')
			.appendTo(container)
			.DOMElement;
		area.value = JSON.stringify(this.jsonReport,undefined,4);
		
		new BaseElement('button')
			.addClass('button')
			.innerHtml('Copy to clipboard')
			.event('click',() => {
				window.navigator.clipboard.writeText(area.value)
					.then(() => {
						Notiflix.Notify.success(`copied`);
					});
			})
			.appendTo(container);
		
		popUp.setContent(container);
		popUp.show();
	}
	
	normalize(apt) {
		const buildingId = apt.buildingEngineId;
		const building = Buildings.getBuilding(buildingId);
		const towerName = building.info.labelName;
		const floor = apt.floorNum;
		const aptNumber = apt.propNum;
		
		return `Building: ${towerName}, Floor: ${floor}, Apt.№ ${aptNumber}`;
	}
}
